import { Icon, Props } from "./DownloadIcon.Parts";

export const DownloadIcon = ({ small, ...props }: Props) => (
  <Icon
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    $small={small}
    {...props}
  >
    <path
      d="M9.68199 17.1583L3.06792 10.5443C2.89281 10.3692 2.89281 10.0843 3.06792 9.90923L4.24756 8.72959C4.42268 8.55447 4.70749 8.55447 4.88261 8.72959L9.68263 13.5296C9.85775 13.7047 10.1426 13.7047 10.3177 13.5296L15.1177 8.72959C15.2928 8.55447 15.5776 8.55447 15.7527 8.72959L16.9324 9.90859C17.1075 10.0837 17.1075 10.3685 16.9324 10.5436L10.3183 17.1577C10.1432 17.3328 9.85839 17.3328 9.68327 17.1577L9.68199 17.1583Z"
      fill="currentColor"
    />
    <path
      d="M10.8339 0H9.16606C8.91807 0 8.71704 0.201033 8.71704 0.44902V15.2128C8.71704 15.4608 8.91807 15.6618 9.16606 15.6618H10.8339C11.0818 15.6618 11.2829 15.4608 11.2829 15.2128V0.44902C11.2829 0.201033 11.0818 0 10.8339 0Z"
      fill="currentColor"
    />
    <path
      d="M19.551 17.4245H0.44902C0.201033 17.4245 0 17.6256 0 17.8736V19.5414C0 19.7893 0.201033 19.9904 0.44902 19.9904H19.551C19.799 19.9904 20 19.7893 20 19.5414V17.8736C20 17.6256 19.799 17.4245 19.551 17.4245Z"
      fill="currentColor"
    />
  </Icon>
);
